// List of all recognized okevent types.
export const OKEVENT = {
	ReceivedMessage: "msgreceived",
	ReceivedReadReceipt: "msgremoteread",
	SentMessage: "msgsent",
	SentMessageCanceled: "msgsent.canceled",
	ReadMessage: "msgread",
	SaveMessageDraft: "msgdraft",
	DeleteConversation: "conversationDelete",
	Unmatch: "unmatch",
	CancelUnmatch: "cancelUnmatch",
	Block: "block",
	Unblock: "unblock",
	CancelBlock: "cancelBlock",
	Hide: "hide",
	Unhide: "unhide",
	CancelHide: "cancelHide",
	Pass: "pass",
	Unpass: "unpass",
	PassCanceled: "pass.canceled",
	Vote: "vote",
	VoteFailure: "vote_failure",
	VoteCanceled: "vote.canceled",
	Favorite: "favorite",
	Unfavorite: "unfavorite",
	Link: "link",
	LinkReject: "link_reject",
	Unlink: "unlink",
	PhotoUpload: "photoupload",
	PhotoDelete: "photodelete",
	Visit: "visit",
	EssaySave: "essaysave",
	WIWUpdate: "wiwUpdate",
	IncognitoToggle: "incognitotoggle",
	QuestionAnswer: "quanswer",
	ProfileActionBar: "profileActionBar",
	HeaderbarPosition: "headerbarPosition",
	MessagesDropdownOpen: "messagesDropdownOpen",
};

// Validate type is an actual OKEVENT type.
export const checkIsValidType = (type) => {
	const isValid = Object.values(OKEVENT).indexOf(type) > -1;

	if (!isValid) {
		throw new Error(`Invalid InstantEvent type "${type}"!`);
	}
};

// Validate callback is a valid function.
export const checkIsValidCallback = (type, callback) => {
	if (!callback || typeof callback !== "function") {
		throw new Error(`Invalid callback passed to ${type} subscription!`);
	}
};

const typeToOkEvent = (type) => `okevent.${type}`;

// CustomEvents put their data in a `detail` key.
// This simply wraps callbacks to extract the data before passing it to the callback.
// And it stores a map of the original callback to the wrapped callback.
const CallbackWrapper = {
	_map: new Map(),

	unwrap(callback) {
		return this._map.get(callback);
	},

	wrap(callback) {
		// We can use this to modify what the callback receives.
		const wrappedCallback = (event) => {
			callback(event.detail || {});
		};

		this._map.set(callback, wrappedCallback);

		return wrappedCallback;
	}
};

// Subscribes to an okevent.
export function subscribeToOkEvent(type, callback, target = document) {
	checkIsValidType(type);
	checkIsValidCallback(type, callback);

	return target.addEventListener(typeToOkEvent(type), CallbackWrapper.wrap(callback));
}

// Subscribes to multiple okevents with the same callback.
export function subscribeToOkEvents(types, callback, target = document) {
	types.every(checkIsValidType); // Verify they're all valid.
	checkIsValidCallback(types, callback);

	return types.forEach((type) => subscribeToOkEvent(type, callback, target));
}

// Unsubscribes from an okevent.
export function unsubscribeFromOkEvent(type, callback, target = document) {
	checkIsValidType(type);

	return target.removeEventListener(typeToOkEvent(type), CallbackWrapper.unwrap(callback));
}

// Sends an okevent.
export function triggerOkEvent(type, data = {}, options = {}) {
	checkIsValidType(type);

	const okEvent = new CustomEvent(typeToOkEvent(type), {
		detail: {
			type: "okevent",
			namespace: type,
			...data,
		},
	});
	document.dispatchEvent(okEvent);

	// Dispatch this event to the parent if available.
	if (options.forwardToParent && window.opener) {
		window.opener.document.dispatchEvent(okEvent);
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/OkEventHelpers.js